import { render } from "./CallStatusDoughnutChart.vue?vue&type=template&id=1ff62fbc&ts=true"
import script from "./CallStatusDoughnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallStatusDoughnutChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallStatusDoughnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ff62fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ff62fbc', __exports__)) {
    api.reload('1ff62fbc', __exports__)
  }
  
  module.hot.accept("./CallStatusDoughnutChart.vue?vue&type=template&id=1ff62fbc&ts=true", () => {
    api.rerender('1ff62fbc', render)
  })

}


export default __exports__